
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, Home } from 'lucide-react';
import PageLayout from '@/components/PageLayout';

const ThankYou = () => {
  return (
    <PageLayout 
      title="Thank You!"
      description="Your review has been successfully submitted."
      className="text-center"
    >
      <div className="flex flex-col items-center justify-center space-y-8 py-12 animate-fade-in">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-green-100">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        
        <div className="space-y-4 max-w-xl mx-auto">
          <h2 className="text-2xl font-semibold text-redflags-dark">Your review has been submitted!</h2>
          <p className="text-redflags-gray">
            Thank you for sharing your experience. Your contribution helps others make informed career decisions.
          </p>
        </div>
        
        <div className="pt-6">
          <Button asChild size="lg" className="bg-redflags-red hover:bg-redflags-red/90 text-white">
            <Link to="/" className="flex items-center gap-2">
              <Home className="w-4 h-4" />
              Return to Homepage
            </Link>
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default ThankYou;
